export enum ToastLevel {
  info = 'info',
  success = 'success',
  warning = 'warning',
  error = 'error',
}
